import Vue from "vue";
// 1 az 2 火龙购 3 Milky Cloud
var appSource = 3;

// 所需替换的文本 &, 为分隔符，多文案同一替换时用分隔符组合
const replaceTextMap = {
  ".myaz.com": {
    2: ".mkyun.com",
    3: ".milkycloud.au",
  },
  // "myaz.com": {
  //   2: "mkyun.com",
  // },
  "Myaz.com": {
    2: "妙客云",
    3: "Milky Cloud",
  },
  "assets-js.myazstore.com": {
    2: "assets-img.mkyun.com",
    3: "assets-img.milkycloud.au",
  },
  "assets.img.myazstore.com": {
    2: "assets-img.mkyun.com",
    3: "assets-img.milkycloud.au",
  },
  ".myazstore.com": {
    2: ".mkyun.com",
    3: ".milkycloud.au",
  },
  "Milky Cloud&,全球购&,azg": {
    2: "妙客云",
    3: "Milky Cloud",
  },
  "az好货通&,好货通": {
    2: "妙商宝",
    3: "妙商宝",
  },
  az: {
    2: "妙客云",
    3: "Milky Cloud",
  },
  地推宝: {
    2: "妙推客",
    3: "妙推客",
  },
  "@/": {
    1: "",
    2: "assets-hhl/",
    3: "assets-mc/",
  },
  symbol: {
    1: "¥",
    2: "¥",
    3: "$",
  },
};

// export function aa() {
//   return "/assets-hhl";
// }

function initAppSource() {
  if (window.location.hostname.includes("myazstore")) {
    appSource = 1;
  } else if (window.location.hostname.includes("mkyun")) {
    appSource = 2;
    if (window.location.hostname.includes("t-au-wap")) {
      appSource = 3;
    }
  } else if (window.location.hostname.includes("milkycloud")) {
    appSource = 3;
  } else {
    appSource = 3;
  }
}

export function getAppId() {
  const appIdMap = {
    1: "wxc59971a11674ac9a",
    2: "wx0aa751f873923a04",
    3: "", // MilkyCloud 服务号待申请
  };
  return appIdMap[appSource] || "";
}

export function getStripePublishableKey() {
  const hostname = window.location.hostname;
  if (hostname.includes("milkycloud.au")) {
    return "pk_live_51T9iWZK6nAf8ryyOQI1K5nPu8mWQKSuQWOTUpmTUQeHW0yYSii9lUgnknkl5ijKr1U2e9aP37XwSIqEL9lgv3LUl00WiX1KEK5";
  }
  return "pk_test_51T9iWmGpslEPyJeL4Jdpx3W8cgt2cZsqndDz4HYLYaiyrMBrgOn7RkV5GKa6f2AkNQecdrIwRJPxovQX2nIALqRP00hSMbxjZ2";
}

export function initGlobal() {
  initAppSource();
  Vue.prototype.$G = $G;
  Vue.prototype.$appSource = appSource;
  Vue.prototype.$appId = getAppId();
  Vue.prototype.$stripePublishableKey = getStripePublishableKey();
}

export function configTitle() {
  let title = "";
  if (appSource === 1) {
    title = "全球购助手";
  } else if (appSource === 2) {
    title = "妙客云";
  } else if (appSource === 3) {
    title = "Milky Cloud";
  } else {
    title = "Milky Cloud";
  }
  document.title = title;
}

// 获取favicon路径
function getFaviconPath() {
  const prefixMap = { 1: "", 2: "hhl-", 3: "mc-" };
  return "/" + prefixMap[appSource] + "favicon.ico";
}

// 动态修改网站图标
export const changeFavicon = () => {
  const iconUrl = getFaviconPath();
  // 检查页面是否已有 favicon 标签
  let link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = iconUrl;
  console.log(document.getElementsByTagName("head")[0]);

  // 如果 favicon 标签已经存在，替换它；否则，添加新标签
  document.getElementsByTagName("head")[0].appendChild(link);
  console.log(document.getElementsByTagName("head")[0]);
};

export function $G(string) {
  return globalReplace(string);
}

function globalReplace(string) {
  if (string === "@/") {
    return replaceTextMap["@/"][appSource];
  }

  if (appSource === 1) {
    return string;
  }

  // let result = string.toLowerCase();
  let result = string.toLowerCase();
  Object.entries(replaceTextMap).some(([key, value]) => {
    let targetString = key;

    if (targetString.includes("&,")) {
      targetString = targetString.split("&,");
    }
    if (typeof targetString === "string") {
      if (key === "Myaz.com" && string.includes(targetString)) {
        result = string;
      }
      const replaceResult = replaceText(result, targetString, value);
      if (replaceResult != result && replaceResult.includes("https://")) {
        result = replaceResult;
        return true;
      }
      result = replaceResult;
    } else if (Array.isArray(targetString)) {
      targetString.forEach((item) => {
        result = replaceText(result, item, value);
      });
    }
    return false;
  });
  return result;
}

function replaceText(string, key, value) {
  let result = string;
  if (string.includes(key)) {
    const regex = new RegExp(key, "g");
    const replaceT = value[`${appSource}`];
    result = result.replace(regex, replaceT);
  }
  return result;
}
